import React from 'react';
import { SigningAppointmentSummaryView } from './SigningAppointmentSummaryView';
import { ePartyPurpose } from '../../../../../ui-toolkit/enums/ePartyPurpose';
import { SummaryItem } from '../../../../shared/Summary/SummaryItem/SummaryItem';
import { useSelectCurrentOrder } from '../../../../../selectors/order/selectCurrentOrder';
import { useListSortedSigningAppointments } from '../../../../../utilities/order/summary/useListSortedSigningAppointments';
import { eTransactionCategory } from '../../../../../ui-toolkit/enums/eTransactionType';

export const BorrowerAppointments: React.FC = () => {
  const { data } = useSelectCurrentOrder();
  const isPurchase = data.transaction.transaction_category === eTransactionCategory.Purchase;
  const { isSigningAppointmentsLoading, borrowerAppointments } = useListSortedSigningAppointments();

  return (
    <SummaryItem
      label={`Signing Appointment (${isPurchase ? 'Buyer' : 'Borrower'})`}
      tab={`summary`}
      isLoading={isSigningAppointmentsLoading}
    >
      {borrowerAppointments.map((borrowerAppointment) => (
        <SigningAppointmentSummaryView
          key={`${borrowerAppointment.id}`}
          appointment={borrowerAppointment}
          partyType={isPurchase ? ePartyPurpose.buyer : ePartyPurpose.borrower}
        />
      ))}
    </SummaryItem>
  );
};
